import React from 'react'
import { connect } from 'react-redux'
import Moment from 'moment'
import { DatePicker } from 'react-widgets';
import { MultiSelect } from '../../components/form/'
import { findKeyValuePairFromValue, isPresentInArray, maskDateInput } from '../../components/HelperFunctions'
import { INSURANCE_BALANCE_DUE_STATUS } from '../Constants';
import Search from './Search'
import Alert from '../Alert';
import DateRangePicker from './DateRangePicker';
import useOrgDateFormat from './helperHooks/useOrgDateFormat';
import useStoreAllowedPaymentMethods from '../../../other/helperHooks/useStoreAllowedPaymentMethods';
import ReceivableFilter from './ReceivableFilter';

const Filter = (props) => {

  const { stores, filters, filterList, labelRemoved, isCurrentDateVisible, staffStoresId, dateRangePicker, isPatientRedirect, isItrustPayEnabled, transactionLogsView, paymentStatusOptions, paymentStatusLabel, paymentStatusFilterKey, staffLabel, storeSpecificPatients, currentStoreId, loading, cardTypes, insuranceBalanceDueFiter, assignTo } = props
  const statusFilterKey = paymentStatusFilterKey || 'status'

  const dateFormatType = useOrgDateFormat()
  const AllowedPaymentMethods = useStoreAllowedPaymentMethods()

  const onlinePaymentSources = [
    { value: "online", name: 'Online' },
    { value: "device", name: 'Terminal' },
    { value: "link", name: 'Pay by text' },
  ]

  // const paymentSources = transactionLogsView ? onlinePaymentSources : [
  //   isItrustPayEnabled ? onlinePaymentSources : [],
  //   { value: "cash", name: 'Cash' },
  //   { value: "check", name: 'Check' },
  //   { value: "card", name: 'Offline' }
  // ].flat();

  const paymentTypes = [
    { id: "sale", name: 'Sale' },
    { id: "refund", name: 'Refund' },
    !transactionLogsView ? [
      { id: "insurance", name: 'Insurance' },
      { id: "void", name: 'Void' }] : []
  ].flat()


  const onFilterChange = (filter) => {
    let isInvalidDateExist = findKeyValuePairFromValue(filter, 'Invalid date')
    if (isInvalidDateExist) {
      Alert.warning(`Invalid date format.`)
    }
    else
      props.filterChangeHook({ ...props.filters, ...filter })
  }


  const ISSUE_TYPE_OPTIONS = [
    { label: 'Eligibility Error', value: 'Eligibility Error' },
    { label: 'Prae-Auth Needed', value: 'Prae-Auth Needed' },
    { label: 'Missing Claim Info', value: 'Missing Claim Info' },
    { label: 'Submission / Clearinghouse Error', value: 'Submission / Clearinghouse Error' },
    { label: 'Denial / Rejection Follow-Up', value: 'Denial / Rejection Follow-Up' },
    { label: 'Underpayment Review', value: 'Underpayment Review' },
    { label: 'Patient Balance Issue', value: 'Patient Balance Issue' },
    { label: 'Write-Off Review', value: 'Write-Off Review' },
    { label: 'Collection Follow-Up', value: 'Collection Follow-Up' }
  ]

  const PRIORITY_OPTIONS = [
    { label: 'Low', value: 'low' },
    { label: 'Medium', value: 'medium' },
    { label: 'High', value: 'high' },
    { label: 'Urgent', value: 'urgent' }
  ]

  const FOLLOW_UP_STATUS_OPTIONS = [
    { label: 'Open', value: 'open' },
    { label: 'In Review', value: 'in_review' },
    { label: 'Waiting on Payer', value: 'waiting_on_payer' },
    { label: 'Waiting on Patient', value: 'waiting_on_patient' },
    { label: 'Corrected / Resubmitted', value: 'corrected_resubmitted' },
    { label: 'Appeal Needed', value: 'appeal_needed' },
    { label: 'Resolved', value: 'resolved' }
  ]

  const PRE_AUTH_STATUS_OPTIONS = [
    { label: 'Not Required', value: 'not_required' },
    { label: 'Needed — Missing', value: 'needed_missing' },
    { label: 'Obtained', value: 'obtained' },
    { label: 'Submitted With Auth', value: 'submitted_with_auth' }
  ]

  const ORDER_AGE_OPTIONS = [

    { label: 'All', value: 'all' },
    { label: '30+', value: '30' },
    { label: '60+', value: '60' },
    { label: '90+', value: '90' },
    { label: '120+', value: '120' },
    { label: '150+', value: '150' },

  ]
  return (
    <div>
      <div className='d-flex flex-row align-items-end filters-width'>
        {!labelRemoved && <span className="text-nowrap">Filter By</span>}
        {isPresentInArray(filterList, 'paymentStores') &&
          <div className={`filter-multiselect store_table_filter ${!labelRemoved && 'ml-5'}`}>
            <MultiSelect
              klass="Store"
              label="Store"
              rpp={100}
              textField='name'
              valueField='id'
              loading={loading}
              isAllSelectVisible={true}
              defaultValues={staffStoresId}
              isSearchVisible="true"
              filter={{ sort: 'name' }}
              onSelectHook={storesIds => onFilterChange({ filter: { ...filters.filter, store_ids: storesIds, staff_ids: [] } })} wrapperClasses="w-100" />
          </div>
        }
        {isPresentInArray(filterList, 'staff') &&
          <div className={`filter-multiselect ${!labelRemoved && 'ml-5'}`}>
            <MultiSelect
              klass="Staff"
              label={staffLabel ?? 'Created By'}
              rpp={1000}
              textField='name'
              valueField='id'
              key={filters.filter.store_ids}
              filter={{ store_ids: filters.filter.store_ids }}
              loading={loading}
              isAllSelectVisible={true}
              isSearchVisible="true"
              showAllSelected={true}
              onSelectHook={staffIds => onFilterChange({ filter: { ...filters.filter, store_ids: filters.filter.store_ids, staff_ids: staffIds } })} wrapperClasses="w-100" />
          </div>
        }
        {isPresentInArray(filterList, 'patients') &&
          <div className="filter-multiselect ml-5">
            <MultiSelect
              klass="Patient"
              label="Patient"
              // placeholder="Select Patient"
              additionalFilters={{ store_id: (storeSpecificPatients && currentStoreId) ? currentStoreId : '' }}
              textField='name'
              valueField='id'
              isSearchVisible="true"
              isPatientRedirect={isPatientRedirect}
              defaultValues={isPatientRedirect ? [isPatientRedirect.id] : null}
              onSelectHook={patientIds => onFilterChange({ filter: { ...filters.filter, patient: patientIds } })} wrapperClasses="w-100" />
          </div>
        }

        {isPresentInArray(filterList, 'stores') &&
          <div className={`filter-multiselect ${!labelRemoved && 'ml-5'}`}>
            <MultiSelect
              data={stores}
              label="Store"
              placeholder="Select Stores"
              textField='store_name'
              valueField='id'
              isSearchVisible="true"
              onSelectHook={storesIds => onFilterChange({ filter: { ...filters.filter, store_ids: storesIds } })} wrapperClasses="w-100" />
          </div>
        }

        {isPresentInArray(filterList, 'dateRange') &&
          <DateRangePicker onFilterChange={(dateFilter) => onFilterChange({ filter: { ...filters.filter, ...dateFilter.filter } })} filters={filters} dateRangePicker={dateRangePicker} loading={loading} maxDate={new Date()} />
        }
        {isPresentInArray(filterList, 'insurances') &&
          <div className="filter-multiselect ml-5">
            <MultiSelect
              klass="Settings::Insurance"
              label="Insurance"
              textField='name'
              rpp={99999999}
              valueField='id'
              loading={loading}
              isSearchVisible="true"
              onSelectHook={insurances => onFilterChange({ filter: { ...filters.filter, insurances: insurances } })} wrapperClasses="w-100" />
          </div>
        }
        {isPresentInArray(filterList, 'insurancePayers') &&
          <div className="filter-multiselect ml-5">
            <MultiSelect
              klass="Settings::Insurance"
              label="Insurance Payer"
              textField='name'
              valueField='id'
              rpp={999}
              filter={{ direction: 'desc', sort: 'count', rpp: 999 }}
              isSearchVisible="true"
              isAllSelectVisible={true}
              onSelectHook={insurance_payers => onFilterChange({ filter: { ...filters.filter, insurance_payers: insurance_payers } })} wrapperClasses="w-100" />
          </div>
        }
        {isPresentInArray(filterList, 'orderDate') &&
          <div className="d-flex flex-column ml-5">
            <span>DOS</span>
            <div className="filter-date date-picker">
              <DatePicker
                format={dateFormatType}
                editFormat={dateFormatType}
                placeholder={dateFormatType}
                onChange={date => onFilterChange({ filter: { ...filters.filter, order_date: Moment(date).format("YYYY/MM/DD") } })}
                onKeyDown={e => e.keyCode === 191 && e.preventDefault()}
                onKeyUp={e => maskDateInput(e)}
              />
            </div>
          </div>
        }
        {isPresentInArray(filterList, 'orderAge') &&
          <div className="d-flex flex-column ml-5">
            <span>Age</span>
            <select className="custom-select bg-white  custom-select-sm" value={ORDER_AGE_OPTIONS.value} onChange={(e) => onFilterChange({ filter: { ...filters.filter, by_age_days: e.target.value } })}>
              {ORDER_AGE_OPTIONS.map((option) =>
                <option value={option.value} key={option.value}>{option.label}</option>
              )}
            </select>
          </div>
        }
        {isPresentInArray(filterList, 'cashReceivable') &&
          <ReceivableFilter filters={filters} onFilterChange={onFilterChange} />
        }
        {isPresentInArray(filterList, 'paymentDate') &&
          <div className="d-flex flex-column ml-5">
            <span>DOP</span>
            <div className="filter-date date-picker">
              <DatePicker
                format={dateFormatType}
                editFormat={dateFormatType}
                placeholder={dateFormatType}
                onChange={date => onFilterChange({ filter: { ...filters.filter, payment_date: Moment(date).format("YYYY/MM/DD") } })}
                onKeyDown={e => e.keyCode === 191 && e.preventDefault()}
                onKeyUp={e => maskDateInput(e)}
              />
            </div>
          </div>
        }
        {isPresentInArray(filterList, 'paymentType') &&
          <div className={`filter-multiselect ml-5`}>
            <MultiSelect
              data={paymentTypes}
              label="Payment Type"
              // placeholder="Select Stores"
              valueField='id'
              textField='name'
              isSearchVisible="false"
              isAllSelectVisible
              onSelectHook={val => onFilterChange({ filter: { ...filters.filter, payment_type: val } })} wrapperClasses="w-100" />
          </div>
        }
        {isPresentInArray(filterList, 'date') &&
          <div className="d-flex flex-column ml-5">
            <span>Date</span>
            <div className="filter-date date-picker">
              <DatePicker
                defaultValue={isCurrentDateVisible && new Date()}
                format={dateFormatType}
                editFormat={dateFormatType}
                placeholder={dateFormatType}
                onChange={date => onFilterChange({ filter: { ...filters.filter, date: Moment(date).format("YYYY/MM/DD") } })}
                onKeyDown={e => e.keyCode === 191 && e.preventDefault()}
                onKeyUp={e => maskDateInput(e)}
              />
            </div>
          </div>
        }
        {isPresentInArray(filterList, 'paymentStatus') &&
          <div className={`filter-multiselect ml-5`}>
            <MultiSelect
              data={paymentStatusOptions ?? [
                { value: "pending", name: 'Pending' },
                { value: "unfinished", name: 'Unfinished' },
                { value: "finalized", name: 'Finalized' },
              ]}
              label={paymentStatusLabel || "Status"}
              // placeholder="Select Stores"
              valueField='value'
              textField='name'
              isSearchVisible="false"
              isAllSelectVisible
              onSelectHook={val => onFilterChange({ filter: { ...filters.filter, [statusFilterKey]: val } })} wrapperClasses="w-100" />
          </div>
        }
        {isPresentInArray(filterList, 'followUpStatus') &&
          <div className="filter-multiselect ml-5">
            <MultiSelect
              data={FOLLOW_UP_STATUS_OPTIONS}
              label="Follow-Up Status"
              textField="label"
              valueField="value"
              isSearchVisible="true"
              isAllSelectVisible
              onSelectHook={val => onFilterChange({ filter: { ...filters.filter, follow_up_status: val } })} wrapperClasses="w-100" />
          </div>
        }
        {isPresentInArray(filterList, 'claimStatus') &&
          <div className={`filter-multiselect ml-5`}>
            <MultiSelect
              data={INSURANCE_BALANCE_DUE_STATUS}
              label="Claim Status"
              // placeholder="Select Stores"
              textField='label'
              valueField='value'
              isSearchVisible="true"
              isAllSelectVisible
              onSelectHook={val => onFilterChange({ filter: { ...filters.filter, claim_status: val } })} wrapperClasses="w-100" />
          </div>
        }
        {isPresentInArray(filterList, 'paymentSource') &&
          <div className={`filter-multiselect ml-5`}>
            <MultiSelect
              label="Payment Source"
              // placeholder="Select Stores"
              data={transactionLogsView ? onlinePaymentSources : AllowedPaymentMethods}
              key={AllowedPaymentMethods.length}
              valueField='value'
              textField='value'
              isSearchVisible="false"
              isAllSelectVisible
              onSelectHook={val => onFilterChange({ filter: { ...filters.filter, mode_of_payment: val } })} wrapperClasses="w-100" />
          </div>
        }
        {isPresentInArray(filterList, 'cardType') &&
          <div className="filter-multiselect ml-5">
            <MultiSelect
              klass={`${cardTypes ? '' : 'StoreSetting'}`}
              label="Card Type"
              textField='name'
              valueField={`${cardTypes ? 'value' : 'name'}`}
              data={cardTypes ?? []}
              filter={{ filter: { category: 'card_types' } }}
              onSelectHook={card_types => onFilterChange({ filter: { ...filters.filter, card_type: card_types } })}
              wrapperClasses="w-100"
            />
          </div>
        }
        {isPresentInArray(filterList, 'checkNumber') &&
          <div className={`mx-5`}>
            <Search placeholder="Check #" wrapperClasses="input-group-sm" onChangeHook={query => onFilterChange({ filter: { ...filters.filter, check_number: query } })} />
          </div>
        }
        {isPresentInArray(filterList, 'claimNumber') &&
          <div className="mx-5">
            <Search placeholder="Claim #" wrapperClasses="input-group-sm" onChangeHook={query => onFilterChange({ filter: { ...filters.filter, claim_number: query } })} />
          </div>
        }
        {isPresentInArray(filterList, 'date_of_birth') &&
          <div className="d-flex flex-column ml-5">
            <span>Date of Birth</span>
            <div className="filter-date date-picker">
              <DatePicker
                defaultValue={isCurrentDateVisible && new Date()}
                format={dateFormatType}
                editFormat={dateFormatType}
                placeholder={dateFormatType}
                onChange={date => onFilterChange({ filter: { ...filters.filter, date_of_birth: Moment(date).format("YYYY/MM/DD") } })}
                onKeyDown={e => e.keyCode === 191 && e.preventDefault()}
                onKeyUp={e => maskDateInput(e)}
              />
            </div>
          </div>
        }
        {isPresentInArray(filterList, 'reason_of_visit') &&
          <div className="filter-multiselect ml-5">
            <MultiSelect
              klass="Settings::Procedure"
              label="Reason For Visit"
              textField='name'
              valueField='id'
              isSearchVisible="true"
              onSelectHook={procedure_ids => onFilterChange({ filter: { ...filters.filter, reason_of_visit: procedure_ids } })} wrapperClasses="w-100" />
          </div>
        }
        {isPresentInArray(filterList, 'impression') &&
          <div className="filter-multiselect ml-5">
            <MultiSelect
              klass="Settings::Impression"
              label="Impression"
              textField='name'
              valueField='id'
              isSearchVisible="true"
              onSelectHook={impression_ids => onFilterChange({ filter: { ...filters.filter, impression: impression_ids } })} wrapperClasses="w-100" />
          </div>
        }
        {isPresentInArray(filterList, 'messageTemplate') &&
          <div className="filter-multiselect ml-5">
            <MultiSelect
              klass="Settings::MessageTemplate"
              label="Template"
              textField='name'
              valueField='id'
              isAllSelectVisible={true}
              isSearchVisible="true"
              onSelectHook={template_ids => onFilterChange({ filter: { ...filters.filter, message_templates: template_ids } })} wrapperClasses="w-100" />
          </div>
        }
      </div>
      {insuranceBalanceDueFiter &&
        <div className='d-flex flex-row align-items-end filters-width mt-7   '>
          <div className="filter-multiselect ml-5">
            <MultiSelect
              data={ISSUE_TYPE_OPTIONS}
              label="Issue Type"
              textField="label"
              valueField="value"
              isSearchVisible="true"
              isAllSelectVisible
              onSelectHook={val => onFilterChange({ filter: { ...filters.filter, issue_type: val } })} wrapperClasses="w-100" />
          </div>
          <div className="filter-multiselect ml-5">
            <MultiSelect
              data={assignTo.staffs}
              label="Assigned To"
              textField="name"
              valueField="id"
              loading={loading}
              isAllSelectVisible={true}
              isSearchVisible="true"
              showAllSelected={true}
              onSelectHook={staffIds => onFilterChange({ filter: { ...filters.filter, account_receivable: staffIds } })} wrapperClasses="w-100" />
          </div>
          <div className="filter-multiselect ml-5">
            <MultiSelect
              data={PRIORITY_OPTIONS}
              label="Priority"
              textField="label"
              valueField="value"
              isSearchVisible="false"
              isAllSelectVisible
              onSelectHook={val => onFilterChange({ filter: { ...filters.filter, priority: val } })} wrapperClasses="w-100" />
          </div>
          <div className="filter-multiselect ml-5">
            <MultiSelect
              data={FOLLOW_UP_STATUS_OPTIONS}
              label="Follow-Up Status"
              textField="label"
              valueField="value"
              isSearchVisible="true"
              isAllSelectVisible
              onSelectHook={val => onFilterChange({ filter: { ...filters.filter, follow_up_status: val } })} wrapperClasses="w-100" />
          </div>
          <div className="d-flex flex-column ml-5">
            <span>Due Date</span>
            <div className="filter-date date-picker">
              <DatePicker
                format={dateFormatType}
                editFormat={dateFormatType}
                placeholder={dateFormatType}
                onChange={date => onFilterChange({ filter: { ...filters.filter, due_date: Moment(date).format("YYYY/MM/DD") } })}
                onKeyDown={e => e.keyCode === 191 && e.preventDefault()}
                onKeyUp={e => maskDateInput(e)}
              />
            </div>
          </div>
          <div className="filter-multiselect ml-5">
            <MultiSelect
              data={PRE_AUTH_STATUS_OPTIONS}
              label="Pre-Auth Status"
              textField="label"
              valueField="value"
              isSearchVisible="true"
              isAllSelectVisible
              onSelectHook={val => onFilterChange({ filter: { ...filters.filter, pre_auth_status: val } })} wrapperClasses="w-100" />
          </div>

          <div className="mx-5">
            <Search placeholder="Age" wrapperClasses="input-group-sm" onChangeHook={query => onFilterChange({ filter: { ...filters.filter, by_age_days: query } })} />
          </div>
          <div className="mx-5">
            <Search placeholder="Copay Balance" wrapperClasses="input-group-sm" onChangeHook={query => onFilterChange({ filter: { ...filters.filter, copay_balance: query } })} />
          </div>
          <div className="mx-5">
            <Search placeholder="Claim #" wrapperClasses="input-group-sm" onChangeHook={query => onFilterChange({ filter: { ...filters.filter, claim_number: query } })} />
          </div>
        </div>
      }
    </div>
  )
}

const mapStateToProps = state => {
  const { filter, staffStore, auth: { user }, organisation, currentStore, storeSetting } = state;
  let staffStoresId = [];
  user.accessible_stores?.filter(store => staffStoresId.push(store.store_id))

  return {
    staffStoresId,
    filters: filter.filters,
    dateRangePicker: filter.dateRangePicker,
    stores: staffStore ? staffStore.staff_stores : [],
    isPatientRedirect: filter.patientPaymentRedirect,
    storeSpecificPatients: organisation.organisation.preferences?.store_specific_patients,
    currentStoreId: currentStore?.store?.id,
  }
}

export default connect(mapStateToProps)(Filter)
